import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { IoMenuOutline } from 'react-icons/io5';
// @mui
import {
  Grid,
  List,
  Button,
  Toolbar,
  ListItem,
  IconButton,
  SwipeableDrawer
} from '@mui/material';
// @custom
import { LogoLink, DrawerContainer, DrawerHeader, DrawerContent } from './styles';
import {
  removeTwoFactorVerified,
  removeSigninEmailNotificationSentFlag
} from 'services/session-storage';
import Logo from 'components/logo';
import useUser from 'hooks/use-user';
import { useSignOut } from 'api/auth';
import { track } from 'utils/segment';
import { profilesUrl } from 'constants/urls';
// @local
import MenuItems from '../menu-items';
import { StyledAppBar } from './styles';

const MobileAppBar = ({ hideProfile }: { hideProfile?: boolean }) => {
  const { user, setUser } = useUser();
  const history = useHistory();
  const [open, setOpen] = React.useState<boolean>(false);
  const { handleSignOut } = useSignOut({
    onSuccess: () => {
      track('Sign Out');
      setUser(null);
      removeTwoFactorVerified();
      removeSigninEmailNotificationSentFlag();
      history.replace('/');
    }
  });
  return (
    <>
      <StyledAppBar position='static'>
        <Toolbar>
          <Grid container justifyContent='space-between' alignItems='center' spacing={1}>
            <LogoLink to={profilesUrl}>
              <Logo />
            </LogoLink>
            {hideProfile ? (
              <div />
            ) : (
              <IconButton onClick={() => setOpen(true)}>
                <IoMenuOutline />
              </IconButton>
            )}
          </Grid>
        </Toolbar>
      </StyledAppBar>
      <SwipeableDrawer
        open={open}
        anchor='right'
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <DrawerContainer>
          <DrawerHeader>
            <LogoLink to={profilesUrl}>
              <Logo />
            </LogoLink>
          </DrawerHeader>
          <DrawerContent>
            <List component='nav' aria-label='navigation'>
              {MenuItems.map(({ allow, component: Component }, index) => {
                const allowed = allow.some((role) => user?.orgRole === role);
                if (allowed) {
                  return (
                    <ListItem
                      key={`appbar-mobile-menu-item-${index}`}
                      onClick={() => setOpen(false)}
                    >
                      <Component />
                    </ListItem>
                  );
                }
                return null;
              })}
              {user && (
                <ListItem>
                  <Button fullWidth aria-label='logout' onClick={() => handleSignOut()}>
                    Logout
                  </Button>
                </ListItem>
              )}
            </List>
          </DrawerContent>
        </DrawerContainer>
      </SwipeableDrawer>
    </>
  );
};

export default MobileAppBar;
